import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GroupBookingGuide } from '../group-booking-guide';
import { GroupBookingWithDetail } from '../group-booking-with-detail';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-group-booking-detail',
  templateUrl: './group-booking-detail.component.html',
  styleUrls: ['./group-booking-detail.component.css']
})
export class GroupBookingDetailComponent implements OnInit {

  groupBooking!: GroupBookingWithDetail;
  groupForm!: FormGroup;
  updatingGroup = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
  }

  updateGroup(groupId: number) {
    this.httpService.getGroupBookingById(groupId).subscribe(res => {
      this.groupBooking = res;
      this.initGroupForm();
    });
  }

  initGroupForm() {
    this.groupForm = this.builder.group({
      generalForm: this.builder.group({
        groupName: [this.groupBooking.name, Validators.required]
      }),
      accompanistForm: this.builder.array([])
    });
    this.initAccompanistForm();
  }

  initAccompanistForm(){
    for(let guide of this.groupBooking.guides){
      this.addAccompanistForm(guide);
    }
  }

  get accompanistForm(): FormArray {
    return this.groupForm.get("accompanistForm") as FormArray;
  }

  get generalForm(): FormGroup {
    return this.groupForm.get("generalForm") as FormGroup;
  }

  addAccompanistForm(guide: GroupBookingGuide) {
    this.accompanistForm.controls.push(
      this.builder.group({
        lastName: [guide.lastName, Validators.required],
        firstName: [guide.firstName, Validators.required],
        phoneNumber: guide.phoneNumber,
        email: guide.email,
        address: guide.address,
        id: guide.id
      })
    );
  }

  addEmptyAccompanistForm() {
    this.accompanistForm.controls.push(
      this.builder.group({
        lastName: [null, Validators.required],
        firstName: [null, Validators.required],
        phoneNumber: null,
        email: null,
        address: null
      })
    );
  }
  
  updateBookingGroup(){
    if(this.generalForm.invalid || this.accompanistForm.invalid){
      return;
    }
    this.groupBooking.name = this.generalForm.value.groupName;
    for(let form of this.accompanistForm.controls){
      if(form.value.id){
        this.updateGuide(form as FormGroup);
      } else{
        this.groupBooking.guides.push(new GroupBookingGuide(
            form.value.firstName,
            form.value.lastName,
            form.value.phoneNumber,
            form.value.email,
            form.value.address
        ));
      }
    }
    this.httpService.putBookingGroup(this.groupBooking).subscribe(res => {
      this.groupBooking = res;
      this.toastService.addSuccess("Success", "Group is successfully updated");
    }, error => {
      this.toastService.addError("Error", error.error.message);
    });
  }

  updateGuide(form: FormGroup){
    for(let guide of this.groupBooking.guides){
      if(guide.id == form.value.id){
        guide.firstName = form.value.firstName;
        guide.lastName = form.value.lastName;
        guide.phoneNumber = form.value.phoneNumber;
        guide.email = form.value.email;
        guide.address = form.value.address;
      }
    }
  }
}
